// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__IQWK8","card":"style_card__iBL13","title":"style_title__dA676","actions":"style_actions__vtNyh","btn":"style_btn___F3Ml"};